<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Edit Card Sets</li>
            </ol>
          </div>
          <h4 class="page-title">Edit Participant Card Sets</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div *ngIf="!!participant" class="card-box">
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="form-group row">
              <div class="col-2">
                <label for="Map description" class="col-form-label">Card sets</label>
              </div>
              <div class="col-6">
                <ng-select2 [(ngModel)]="selectedCardSet" [ngModelOptions]="{standalone: true}"
                            [data]="mapCustomCardSets"
                            [options]="select2options" placeholder="Card sets"></ng-select2>
              </div>
              <div class="col-4">
                <button class="btn btn-info waves-effect waves-light" (click)="addSinkNodeMappedFields()" type="button">
                  Add CardSets<i class="mdi mdi-plus"></i></button>
              </div>

            </div>
            <hr/>

            <ng-container *ngIf="cardSetsByParticipant && cardSetsByParticipant.length > 0">
              <div class="form-group row" *ngFor="let cardSetsFields of cardSetsByParticipant">

                <div class="col-2">
                  <label for="CardSet" class="col-form-label">Card Set</label>
                </div>
                <div class="col-2">
                  <ng-select2 [disabled]="true" [(ngModel)]="cardSetsFields.cardSet"
                              [ngModelOptions]="{standalone: true}"
                              [data]="cardSets" [options]="select2options" placeholder="Card sets"></ng-select2>
                </div>

                <div class="col-2">
                  <label for="participantId" class="col-form-label">Participant
                    Id: {{cardSetsFields.participantId}}</label>
                </div>
                <div class="col-2">
                  <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-delete"
                          (click)="determineDeleteDialog(cardSetsFields.cardSet)" type="button">Delete
                  </button>
                </div>

              </div>
            </ng-container>

            <div class="form-group row" offset-3 col-9 *ngIf="error">
              <div class="col-10">
                <p class="text-danger">{{errorMessage}}</p>
              </div>
            </div>
            <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
              <ng-container *ngIf="!!createResult.message">
                <p class="text-danger">{{createResult.message}}</p>
              </ng-container>
            </div>


            <div class="form-group mb-0 justify-content-end row">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
